import { ArchiveMutation } from "../hooks/useArchiveState";
import { ProviderGroupControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useArchiveProviderGroup = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new ProviderGroupControllerApi(
      getConfigObject()
    ).updateProviderGroupArchiveStatus(param.id, param.status)
  );
